export default "__VITE_ASSET__sJ0grTT8__"